"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.HeroBody = void 0;
require("./HeroBody.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Tag = _interopRequireDefault(require("../Tag/Tag"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * HeroBody component
 *
 * @method
 * @param {HeroBodyProps} props
 * @returns HeroBody
 */

const HeroBody = props => {
  const {
    body,
    bodyStyle = defaultProps.bodyStyle,
    bodySecondLine,
    eyebrow,
    headline,
    headlineStyle = defaultProps.headlineStyle,
    headlineTag = defaultProps.headlineTag,
    tag,
    textAlign = defaultProps.textAlign,
    textColor,
    textPosition = defaultProps.textPosition
  } = props;
  const hasTag = tag?.message || tag?.variant === 'urgency';
  const componentClassName = (0, _classnames.default)('pal-c-HeroBody', {
    [`pal-c-HeroBody__textPosition--${textPosition}`]: textPosition
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, hasTag && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-HeroBody__tag"
  }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
    backgroundColor: tag.backgroundColor,
    boldText: tag.boldText,
    endTime: tag.endTime,
    icon: tag.icon,
    message: tag.message,
    size: tag.size,
    startTime: tag.startTime,
    style: tag.style,
    textColor: tag.textColor,
    theme: tag.theme,
    timerMeta: tag.timerMeta,
    timerType: tag.timerType,
    variant: tag.variant
  })), eyebrow && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-HeroBody__eyebrow"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "eyebrow",
    htmlTag: "span",
    textAlign: textAlign,
    textColor: textColor
  }, eyebrow)), headline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-HeroBody__headline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: headlineStyle,
    textAlign: textAlign,
    textColor: textColor,
    htmlTag: headlineTag
  }, headline)), body && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-HeroBody__body"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: bodyStyle,
    htmlTag: "p",
    textAlign: textAlign,
    textColor: textColor
  }, body)), bodySecondLine && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-HeroBody__bodySecondLine"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: bodyStyle,
    htmlTag: "p",
    textAlign: textAlign,
    textColor: textColor
  }, bodySecondLine)));
};

/**
 * Property type definitions
 * @typedef HeroBodyProps
 * @type {object}
 * @property {string} textPosition - textAlign for the text
 * @property {string} eyebrow - smaller text above the headline
 * @property {string} body - body text/description of the hero body
 * @property {string} bodyStyle - body text size of the hero body
 * @property {object} tag - tag component above the eyebrow
 * @property {string} textAlign - textAlign for the text
 * @property {string} textColor - text color of the hero body
 * @property {string} headline - headline text of the hero body
 * @property {string} headlineStyle - headline font size
 * @property {string} headlineTag - Sets the HTML tag for the container
 */
exports.HeroBody = HeroBody;
const propTypes = exports.propTypes = {
  /* textPosition for the text */
  textPosition: _propTypes.default.oneOf(['left', 'center', 'right']),
  /* smaller text above the headline */
  eyebrow: _propTypes.default.string,
  /* body text/description of the hero body */
  body: _propTypes.default.string,
  /* body text size of the hero body */
  bodyStyle: _propTypes.default.oneOf(['body-xlg', 'body-lg', 'body', 'body-sm', 'label', 'label-sm', 'title-xlg', 'title-lg', 'title', 'title-sm', 'headline-lg', 'headline', 'headline-sm', 'display-xlg', 'display-lg', 'display', 'display-sm', 'displayBody', 'displayBody-sm']),
  /*  Allows passing an object to the tag prop*/
  /*  See tag component for more detail ../Tag/Tag.jsx */
  tag: _propTypes.default.object,
  /* textAlign for the text */
  textAlign: _propTypes.default.oneOf(['left', 'center', 'right']),
  /* textColor for the text */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout']),
  /* headline text of the hero body */
  headline: _propTypes.default.string,
  /* headline font size */
  headlineStyle: _propTypes.default.oneOf(['body-xlg', 'body-lg', 'body', 'body-sm', 'label', 'label-sm', 'title-xlg', 'title-lg', 'title', 'title-sm', 'headline-lg', 'headline', 'headline-sm', 'display-xlg', 'display-lg', 'display', 'display-sm', 'displayBody', 'displayBody-sm']),
  /* Sets the HTML tag for the container */
  headlineTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} bodyStyle - bodyStyle: 'displayBody' - sets the subtitle font size
 * @property {string} headlineStyle - headlineStyle: 'display-lg' - sets the headline font size
 * @property {string} headlineTag - headlineTag: 'h1' - sets the headline tag
 * @property {string} textAlign - textAlign: 'left' - sets the textAlign for the text
 * @property {string} textPosition - textPosition: 'left' - sets the textAlign for the content
 */
const defaultProps = exports.defaultProps = {
  bodyStyle: 'displayBody',
  headlineStyle: 'display-lg',
  headlineTag: 'h2',
  textAlign: 'left',
  textPosition: 'left'
};
HeroBody.propTypes = propTypes;
var _default = exports.default = HeroBody;